import useFeatureSettingsUpdate from './useFeatureSettingsUpdate';

export default function useTimeCardsSettingsUpdate() {
  return useFeatureSettingsUpdate('timeCards');
}
